import React from "react";
import styles from "./filter.module.css";


const Filter = () => {

  return (
    <div className={styles.container}>
      <p>Filter</p>
    </div>
  );
};

export default Filter;
